import {Avatar, Button, Card, List, Pagination, Tag} from "antd";
import {Link1Icon} from "@radix-ui/react-icons";
import {FaMapMarkedAlt} from "react-icons/fa";
import {InfoIcon} from "lucide-react";

export const CompanyApplications = ({articles}) => {
    return (
        <>
            <List
                itemLayout="vertical"
                dataSource={articles}
                renderItem={item => (
                    <Card className="mb-4 shadow-md hover:border-green-500 hover:cursor-pointer p-4">
                        <div className="flex flex-col sm:flex-row items-center gap-4">
                            <Avatar size={80} src={item.image}/>
                            <div className="flex-1 text-center sm:text-left">
                                <h2 className="font-semibold text-lg">{item.title}</h2>
                                <div className="flex flex-wrap gap-2 my-2 justify-center sm:justify-start">
                                    {item.tags.map(tag => <Tag color="geekblue" key={tag}>{tag}</Tag>)}
                                </div>
                            </div>
                        </div>
                        <h4 className="font-semibold mt-4">Mô tả</h4>
                        <p className="text-sm sm:text-base">{item.description}</p>
                        <h4 className="font-semibold mt-4">Về công ty</h4>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start gap-2 sm:gap-4">
                            <div className="flex items-center gap-2">
                                <Link1Icon className="size-4"/>
                                <a href={item.link} target="_blank" rel="noopener noreferrer"
                                   className="text-blue-500 break-all">
                                    {item.link}
                                </a>
                            </div>
                            <div className="flex items-center gap-2">
                                <FaMapMarkedAlt className="size-4"/>
                                <p className="text-sm sm:text-base">{item.location}</p>
                            </div>
                        </div>
                        <div
                            className="flex flex-col sm:flex-row justify-between items-center text-gray-500 text-sm mt-4 gap-2 sm:gap-0">
                            <span className="text-center sm:text-left">Cập nhật lần cuối: {item.date}</span>
                            <Button className="shadow-md flex items-center" icon={<InfoIcon size={20}/>} type="text">Xem
                                chi tiết</Button>
                        </div>
                    </Card>
                )}
            />
            <Pagination className="mt-4 flex justify-center" defaultCurrent={1} responsive total={50}/>
        </>
    );
}
